class SysConfig {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title:string = 'MLS';
    /**
     * @description token在Cookie中存储的天数，默认1天
     */
    cookieExpires:number = 1;
    /**
     * @description 是否使用国际化，默认为true
     *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
     *              用来在菜单中显示文字
     */
    useI18n:boolean = true;
    /**
     * @description api请求基础路径
     */
    baseUrl:string = (process.env.NODE_ENV === 'production' ? process.env.VUE_APP_SERVER_URL : 'http://localhost:21021') + '/api/';
    /**
     * @description 默认打开的首页的路由name值，默认为home
     */
    homeName:string = 'home';
    /**
     * @description 需要加载的插件
     */
    plugin:any= {
      'error-store': {
        showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
        developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
      }
    }
    /**
     * @description 多租户
     */
    multiTenancy:boolean = false;

    /**
     *  @description 是否开启多语言选择
     */
    isEnableLanguageSwitch = false;
    /**
     * 启用SSO登录
     */
    enableSSO:boolean = false;
    /**
     * 启用多Tab标签
     */
     enableTabNavigate:boolean = false;
  }
  const appConfig = new SysConfig();
  export default appConfig
  